import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appReadMoreExpand]',
})
export class ReadMoreExpandDirective implements AfterViewInit, OnDestroy {
  @Input() limit: number = 50; //to get the custom text limit
  @Input() toggle: boolean = false; //true: 'Read Less' button will be present
  @Input() popup: boolean = false;
  @Input() closeIcon: string = '';
  txtSpan!: HTMLSpanElement;
  btnSpan!: HTMLSpanElement;
  popupDialog!: HTMLSpanElement;
  popupDialogContent!: HTMLDivElement;
  closebtnSpan!: HTMLSpanElement;
  listeners: any[] = []; //add event listeners to unsubscribe all at the end
  myOptions: any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
  ) {}
  ngAfterViewInit(): void {
    //step 1  ---> change the text in HTML DOM element (<p>, <div>, <span>, <h1>, etc)
    let text: string = this.el.nativeElement.innerHTML;
    if (this.popup) {
      if (
        text.length > this.limit
      ) //perform below logic only when text length exceeds limit
      {
        this.renderer.setProperty(
          this.el.nativeElement,
          'innerHTML',
          text.substring(0, this.limit),
        );

        //step 2 ---> create txtSpan(remaining text) and btnSpan(Read More button)

        this.txtSpan = this.renderer.createElement('span');
        this.btnSpan = this.renderer.createElement('span');
        this.popupDialog = this.renderer.createElement('span');
        this.popupDialogContent = this.renderer.createElement('div');
        this.closebtnSpan = this.renderer.createElement('span');

        this.renderer.addClass(this.popupDialog, 'popover');
        this.renderer.addClass(this.popupDialogContent, 'popover-content');
        this.el.nativeElement.appendChild(this.popupDialog);

        this.renderer.addClass(this.btnSpan, 'read-more');
        this.renderer.addClass(this.closebtnSpan, 'close-btn');
        //step 3 ---> set initial properties and styles for both span elements
        this.renderer.setProperty(
          this.txtSpan,
          'innerHTML',
          text.substring(0, this.limit),
        );
        this.renderer.setProperty(
          this.popupDialogContent,
          'innerHTML',
          text.replaceAll(',', ', '),
        );
        this.renderer.setStyle(this.txtSpan, 'display', 'none');
        this.renderer.setStyle(this.popupDialog, 'min-width', '300px');
        this.renderer.setStyle(this.popupDialog, 'max-width', '400px');
        this.renderer.setStyle(this.popupDialog, 'display', 'none');
        this.renderer.setProperty(
          this.btnSpan,
          'innerHTML',
          '<a class="readmore" style="color:#1976d2;"  [options]="myOptions" tooltip="More Details">...</a>',
        );
        this.renderer.setProperty(
          this.closebtnSpan,
          'innerHTML',
          '<a><i class="' + this.closeIcon + '"</a>',
        );
        //below css properties are optional
        this.renderer.setStyle(this.btnSpan, 'cursor', 'pointer');
        this.renderer.setStyle(this.btnSpan, 'margin-left', '1ch');
        this.renderer.setStyle(this.btnSpan, 'text-decoration', 'underline');
        this.renderer.setStyle(this.closebtnSpan, 'position', 'absolute');
        this.renderer.setStyle(this.closebtnSpan, 'top', '5px');
        this.renderer.setStyle(this.closebtnSpan, 'right', '10px');
        this.renderer.setStyle(this.closebtnSpan, 'cursor', 'pointer');
        this.renderer.setStyle(this.popupDialogContent, 'max-height', '300px');
        this.renderer.setStyle(this.popupDialogContent, 'overflow-y', 'auto');
        this.renderer.setStyle(this.popupDialogContent, 'margin-top', '10px');
        this.renderer.setStyle(
          this.popupDialogContent,
          'scrollbar-width',
          'thin',
        );

        //step 4 ---> add onClick handler for 'Read More' button span
        if (this.toggle)
          //case when toggling needs to be enabled
          this.listeners.push(
            this.renderer.listen(this.btnSpan, 'click', () => {
              if (
                this.popupDialog.style.display == 'none'
              ) //case when the text is hidden(default case)
              {
                this.renderer.setStyle(this.popupDialog, 'display', 'block');
              } else //case when the text is visible
              {
                this.renderer.setStyle(this.popupDialog, 'display', 'none');
                this.renderer.setStyle(this.txtSpan, 'display', 'none');
                this.renderer.setProperty(
                  this.btnSpan,
                  'innerHTML',
                  '<a class="readmore" style="color:#1976d2;" [options]="myOptions" tooltip="More Details">...</a>',
                );
              }
            }),
            this.renderer.listen(this.closebtnSpan, 'click', () => {
              if (
                this.popupDialog.style.display == 'none'
              ) //case when the text is hidden(default case)
              {
                this.renderer.setStyle(this.popupDialog, 'display', 'block');
              } else //case when the text is visible
              {
                this.renderer.setStyle(this.popupDialog, 'display', 'none');
                this.renderer.setStyle(this.txtSpan, 'display', 'none');
                this.renderer.setProperty(
                  this.btnSpan,
                  'innerHTML',
                  '<a class="readmore" style="color:#1976d2;" [options]="myOptions" tooltip="More Details">...</a>',
                );
              }
            }),
          ); //case when toggling is off (only show text)
        else
          this.listeners.push(
            this.renderer.listen(this.btnSpan, 'click', () => {
              this.renderer.setStyle(this.txtSpan, 'display', 'inline');
              this.renderer.setStyle(this.btnSpan, 'display', 'none');
            }),
            this.renderer.listen(this.closebtnSpan, 'click', () => {
              this.renderer.setStyle(this.txtSpan, 'display', 'inline');
              this.renderer.setStyle(this.btnSpan, 'display', 'none');
              this.renderer.setStyle(this.popupDialog, 'display', 'none');
            }),
          );

        //step 5 ---> append both span to the HTML DOM element
        this.renderer.appendChild(this.el.nativeElement, this.txtSpan);
        this.renderer.appendChild(this.el.nativeElement, this.btnSpan);
        this.renderer.appendChild(this.popupDialog, this.closebtnSpan);
        this.renderer.appendChild(this.popupDialog, this.popupDialogContent);
      }
    } else if (
        text.length > this.limit
      ) //perform below logic only when text length exceeds limit
      {
        this.renderer.setProperty(
          this.el.nativeElement,
          'innerHTML',
          text.substring(0, this.limit),
        );

        //step 2 ---> create txtSpan(remaining text) and btnSpan(Read More button)
        this.txtSpan = this.renderer.createElement('span');
        this.btnSpan = this.renderer.createElement('span');

        //step 3 ---> set initial properties and styles for both span elements
        this.renderer.setProperty(
          this.txtSpan,
          'innerHTML',
          text.substring(this.limit),
        );
        this.renderer.setStyle(this.txtSpan, 'display', 'none');

        this.renderer.setProperty(
          this.btnSpan,
          'innerHTML',
          '<a style="color:#1976d2;"  [options]="myOptions" tooltip="More Details">...</a>',
        );
        //below css properties are optional
        this.renderer.setStyle(this.btnSpan, 'cursor', 'pointer');
        this.renderer.setStyle(this.btnSpan, 'margin-left', '1ch');
        this.renderer.setStyle(this.btnSpan, 'text-decoration', 'underline');

        //step 4 ---> add onClick handler for 'Read More' button span
        if (this.toggle)
          //case when toggling needs to be enabled
          this.listeners.push(
            this.renderer.listen(this.btnSpan, 'click', () => {
              if (
                this.txtSpan.style.display == 'none'
              ) //case when the text is hidden(default case)
              {
                this.renderer.setStyle(this.txtSpan, 'display', 'inline');
                this.renderer.setProperty(
                  this.btnSpan,
                  'innerHTML',
                  '<br><a style="color:#1976d2;">Read Less</a>',
                );
              } else //case when the text is visible
              {
                this.renderer.setStyle(this.txtSpan, 'display', 'none');
                this.renderer.setProperty(
                  this.btnSpan,
                  'innerHTML',
                  '<a style="color:#1976d2;" [options]="myOptions" tooltip="More Details">...</a>',
                );
              }
            }),
          ); //case when toggling is off (only show text)
        else
          this.listeners.push(
            this.renderer.listen(this.btnSpan, 'click', () => {
              this.renderer.setStyle(this.txtSpan, 'display', 'inline');
              this.renderer.setStyle(this.btnSpan, 'display', 'none');
            }),
          );

        //step 5 ---> append both span to the HTML DOM element
        this.renderer.appendChild(this.el.nativeElement, this.txtSpan);
        this.renderer.appendChild(this.el.nativeElement, this.btnSpan);
      }
  }

  ngOnDestroy(): void {
    this.listeners.forEach((val) => val());
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: EventTarget | null): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this.el.nativeElement.contains(targetElement);
    if (!clickedInside && this.popupDialog) {
      if (this.popupDialog.style.display == 'block') {
        this.renderer.setStyle(this.popupDialog, 'display', 'none');
      }
    }
  }
}
